import { plsTokens } from '@pulsex/tokens'
import { getAddress } from 'viem'
import { SerializedFarmConfig } from '..'

const farms: SerializedFarmConfig[] = [
  /**
   * Farms (PID 0, 1) should always be at the top of the file.
   */
  {
    pid: 0,
    lpSymbol: 'PLSX-WPLS LP',
    lpAddress: '0x1b45b9148791d3a104184Cd5DFE5CE57193a3ee9',
    token: plsTokens.plsx,
    quoteToken: plsTokens.wpls,
    protocol: 'V1',
  },
  {
    pid: 1,
    lpSymbol: 'DAI from Ethereum-WPLS LP',
    lpAddress: '0xE56043671df55dE5CDf8459710433C10324DE0aE',
    token: plsTokens.dai,
    quoteToken: plsTokens.wpls,
    protocol: 'V1',
  },
  {
    pid: 2,
    lpSymbol: 'USDC from Ethereum-WPLS LP',
    lpAddress: '0x6753560538eca67617a9ce605178f788be7e524e',
    token: plsTokens.usdc,
    quoteToken: plsTokens.wpls,
    protocol: 'V1',
  },
  {
    pid: 3,
    lpSymbol: 'HEX from Ethereum-WPLS LP',
    lpAddress: '0xaa1ea17e7499f892ab9e45e139d843049942fb7a',
    token: plsTokens.ehex,
    quoteToken: plsTokens.wpls,
    protocol: 'V1',
  },
  {
    pid: 4,
    lpSymbol: 'WETH from Ethereum-WPLS LP',
    lpAddress: '0x42AbdFDB63f3282033C766E72Cc4810738571609',
    token: plsTokens.weth,
    quoteToken: plsTokens.wpls,
    protocol: 'V1',
  },
  {
    pid: 5,
    lpSymbol: 'USDT from Ethereum-WPLS LP',
    lpAddress: '0x322Df7921F28F1146Cdf62aFdaC0D6bC0Ab80711',
    token: plsTokens.usdt,
    quoteToken: plsTokens.wpls,
    protocol: 'V1',
  },
  {
    pid: 6,
    lpSymbol: 'HEX from Ethereum-HEX LP',
    lpAddress: '0x1dA059091d5fe9F2d3781e0FdA238BB109FC6218',
    token: plsTokens.ehex,
    quoteToken: plsTokens.hex,
    protocol: 'V1',
  },
  {
    pid: 7,
    lpSymbol: 'HEX-WPLS LP',
    lpAddress: '0xf1F4ee610b2bAbB05C635F726eF8B0C568c8dc65',
    token: plsTokens.hex,
    quoteToken: plsTokens.wpls,
    protocol: 'V1',
  },
  {
    pid: 8,
    lpSymbol: 'INC-WPLS LP',
    lpAddress: '0xf808Bb6265e9Ca27002c0A04562Bf50d4FE37EAA',
    token: plsTokens.inc,
    quoteToken: plsTokens.wpls,
    protocol: 'V1',
  },
  {
    pid: 9,
    lpSymbol: 'INC-PLSX LP',
    lpAddress: '0x7Dbeca4c74d01cd8782D4EF5C05C0769723fb0ea',
    token: plsTokens.inc,
    quoteToken: plsTokens.plsx,
    protocol: 'V1',
  },
  {
    pid: 10,
    lpSymbol: 'WBTC from Ethereum-WBTC LP',
    lpAddress: '0x80a600F7Bd4eb31183A23175dC61c269E6d20588',
    token: plsTokens.wbtc,
    quoteToken: plsTokens.ewbtc,
    protocol: 'V1',
  },
  {
    pid: 11,
    lpSymbol: 'WBTC-WPLS LP',
    lpAddress: '0x46E27Ea3A035FfC9e6d6D56702CE3D208FF1e58c',
    token: plsTokens.wbtc,
    quoteToken: plsTokens.wpls,
    protocol: 'V1',
  },
  {
    pid: 12,
    lpSymbol: 'WBTC from Ethereum-WPLS LP',
    lpAddress: '0xDB82b0919584124A0Eb176ab136A0Cc9F148B2D1',
    token: plsTokens.ewbtc,
    quoteToken: plsTokens.wpls,
    protocol: 'V1',
  },
  {
    pid: 14,
    lpSymbol: 'PEPE from Ethereum-PEPE LP',
    lpAddress: '0xB01855CAf7e4550088a4d735d902ABdF6655b1d6',
    token: plsTokens.epepe,
    quoteToken: plsTokens.pepe,
    protocol: 'V1',
  },
  {
    pid: 15,
    lpSymbol: 'PEPE-WPLS LP',
    lpAddress: '0xDDAa0F4Bf2eAeE8e13B2045d03075C1822856DC6',
    token: plsTokens.pepe,
    quoteToken: plsTokens.wpls,
    protocol: 'V1',
  },
  {
    pid: 16,
    lpSymbol: 'LINK from Ethereum-WPLS LP',
    lpAddress: '0xF0911ae86D32b3f19C52c7239fAF8d356c62D593',
    token: plsTokens.elink,
    quoteToken: plsTokens.wpls,
    protocol: 'V1',
  },
  {
    pid: 18,
    lpSymbol: 'UNI from Ethereum-WPLS LP',
    lpAddress: '0x2736F275C4814b6Fa9023e09772BbF6E68C63AcD',
    token: plsTokens.euni,
    quoteToken: plsTokens.wpls,
    protocol: 'V1',
  },
].map((p) => ({
  ...p,
  token: p.token.serialize,
  quoteToken: p.quoteToken.serialize,
  lpAddress: getAddress(p.lpAddress),
}))

export default farms
